import { render, staticRenderFns } from "./DeletePatchFiles.vue?vue&type=template&id=52230eee&"
import script from "./DeletePatchFiles.vue?vue&type=script&lang=ts&"
export * from "./DeletePatchFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports